import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProviderTypes } from '@guryou/core';
import { PersonRuningIcon, WorkoutIcon } from '@guryou/html-components';
import { useOnboardContext } from 'onboard/context';
import { SystemChoiceCard } from 'components/shared';

const ProviderType = ({ type = ProviderTypes.centers }) => {
  const { t } = useTranslation();
  const { setPrevStateWithStep } = useOnboardContext();

  const handleClick = () => {
    setPrevStateWithStep({ providerType: type }, 2);
  };

  return (
    <SystemChoiceCard
      icon={type === ProviderTypes.centers ? <WorkoutIcon /> : <PersonRuningIcon />}
      title={type === ProviderTypes.centers ? t('ONBOARD.center') : t('ONBOARD.professionals')}
      description={type === ProviderTypes.centers ? t('ONBOARD.centerDescription') : t('ONBOARD.profDescription')}
      onClick={handleClick}
    />
  );
};

export default ProviderType;
